module.exports = __webpack_public_path__ + "static/lastgen-island-4bb7a20d29e8ed94d6be3dadbcc7ef6e.webm";